module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABEklEQVRYR+2WwRGCMBBFd2lAtAc8awViOeLFDsQixHLECvQsPSgVsM4yhmEYBpYMCRzCOZv/8smHjzDxgxPrgxjAv2UhEpwRINSFJoCUEC75IUjVHiIAFvcI7jxEAA9dAATY8WyBsFcQIoBlkqU8XBBt8+P6pQvgX98bD/HJh/hGQemkCGCVZFQf0gXgOXWYTxSU2g5gXg40o6Zuq5U70BY1IjrxrbcC0BU1KwBdIg7AOeAccA5Y6QNdNjc+01WdGtoLVJ1rbUR97/n/o4pVrRoqruocIcStnbAPQEdQMlP1gTEBuPsB4iKPgt4CawSg2fu6nJgPgMmoiRwwGTURAC8yFTUxgCQ2Y68R1fKxRev7/QA+T3Yw/mQK3wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copy.png
// module id = zOHj
// module chunks = 0